import React from 'react';
import { Grid, Typography, Card, CardContent, Button, Box } from '@material-ui/core';

import './local.css';

const GoalCard = ({ title, subtitle, href, actionText, iconColor, onClick }) => {
  return (
    <Card className="goal-card__card" elevation={0}>
      <CardContent style={{ padding: 0, width: '100%', display: 'flex' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={9}>
            <Box display="flex" alignItems="center" mb={1}>
              <Box
                width={8}
                height={24}
                mr={1.5}
                borderRadius={4}
                style={{ backgroundColor: iconColor }}
              />
              <Typography className="home-page__card-title">{title}</Typography>
            </Box>
            <Typography className="home-page__card-body">{subtitle}</Typography>
          </Grid>
          <Grid item xs={12} md={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              onClick={onClick}
              style={{
                backgroundColor: iconColor,
                color: '#fff',
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                padding: '8px 16px',
              }}
            >
              {actionText}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default GoalCard;

